export default {
  init() {
    // JavaScript to be fired on the home page
    $( document ).ready(function() {
      $('#hero-search-filter').on('click', function(e) {
        e.preventDefault();
        $('#hero-search-filter-fields').toggleClass('hidden');
        $('.search-type-text').toggleClass('invisible');
        $('.search-location-text').toggleClass('invisible');
        showSearchButton();
      });
      $('#hero-search-type').on('click', function(e) {
        e.preventDefault();
        $('#hero-search-type-fields').toggleClass('hidden');
        $('.search-location-text').toggleClass('invisible');
        showSearchButton();
      });
      $('#hero-search-location').on('click', function(e) {
        e.preventDefault();
        $('#hero-search-location-fields').toggleClass('hidden');
        showSearchButton();
      });
      $('input[type=checkbox]').on('click', function() {
        if ($("input[type=checkbox][name=filter]:checked").val()) {
          $('#hero-search-filter').text($("input[type=checkbox][name=filter]:checked").val());
        }
        if ($("input[type=checkbox][name=type]:checked").val()) {
          $('#hero-search-type').text($("input[type=checkbox][name=type]:checked").val());
        }
        if ($("input[type=checkbox][name=city]:checked").val()) {
          $('#hero-search-location').text(decodeURIComponent($("input[type=checkbox][name=city]:checked").val()));
        }
      })
    });
    $('.filter-fields fieldset').on('mouseout', function(event) {
      var e = event.toElement || event.relatedTarget;
      if (e.parentNode == this || e == this || e.parentNode.parentNode == this) {
          return;
      }
      $('.filter-fields').addClass('hidden');
      $('.search-type-text').removeClass('invisible');
      $('.search-location-text').removeClass('invisible');
      showSearchButton();
    });
    function showSearchButton() {
      if ($('#hero-search-filter-fields').hasClass('hidden') && $('#hero-search-type-fields').hasClass('hidden') && $('#hero-search-location-fields').hasClass('hidden')) {
        $('#homepage-search-submit').removeClass('hidden');
      } else {
        $('#homepage-search-submit').addClass('hidden');
      }
    }
    /* eslint-disable */
    let typeMap = {
      'office': 'property-type-office',
      'industrial': 'property-type-industrial',
      'retail': 'property-type-retail',
      'flex': 'property-type-flex'
    }
    function returnTypeId(val) {
      return typeMap[val];
    }
    function homepageSearch() {
      let filter = "",
          type = "",
          city = "";
      $("input[type=checkbox][name=filter]:checked").map(function(e, i) {
        filter = (filter !== '') ? filter + ',' + $(i).val() : $(i).val();
      });
      $("input[type=checkbox][name=type]:checked").map(function(e, i) {
        type = (type !== '') ? type + ',' + returnTypeId($(i).val()) : returnTypeId($(i).val());
      });
      $("input[type=checkbox][name=city]:checked").map(function(e, i) {
        city = (city !== '') ? city + ',' + $(i).val() : $(i).val();
      });
      window.location.href = '/properties/?filter=' + filter + '&type=' + type + '&city=' + city;
    }
    $('a#homepage-search-submit').click(function(e) {
      e.preventDefault();
      homepageSearch();
    });
    /* eslint-enable */
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};